import { useEffect } from 'react';

/**
 * KeepAlive Component
 * 
 * This component runs silently in the background of the application.
 * It sends a request to the /api/keepalive endpoint every 5 minutes
 * to prevent the Vercel serverless functions from going to sleep.
 */
export function KeepAlive() {
  useEffect(() => {
    // Function to ping the server
    const pingServer = async () => {
      try {
        // Fetch the keepalive endpoint
        const response = await fetch('/api/keepalive');
        
        if (response.ok) {
          const contentType = response.headers.get('content-type');
          if (contentType && contentType.includes('application/json')) {
            const data = await response.json();
            // Log the active status and timestamp to the browser console
            console.log(`[Keep-Alive] Server is active at ${data.timestamp}`);
          } else {
            const text = await response.text();
            if (text.includes('export default')) {
              console.log('[Keep-Alive] Pinged API source (dev mode)');
            } else {
              console.log('[Keep-Alive] Server ping successful (non-JSON response)');
            }
          }
        } else {
          console.warn('[Keep-Alive] Server ping failed with status:', response.status);
        }
      } catch (error) {
        // Suppress the error in development to avoid console spam
        // console.error('[Keep-Alive] Failed to ping server:', error);
      }
    };

    // 1. Ping immediately when the app loads (optional, good for testing)
    pingServer();

    // 2. Set up an interval to ping every 5 minutes (300,000 milliseconds)
    const intervalId = setInterval(pingServer, 5 * 60 * 1000);

    // 3. Clean up the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, []);

  // This component does not render any visible UI
  return null;
}
